import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";

import { ReportChip } from "../components";
import propTypes from "../../../../constants/propTypes";

const ReportChipContainer = styled.div`
  position: relative;
  display: inline-block;
  &:not(:last-child) {
    margin-right: 16px;
  }
  margin-top: 8px;
`;

const StyledCircularProgress = styled(CircularProgress)`
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  color: white;
`;

export const ReportLink = ({ label, Icon, onClick, loading, ...report }) => {
  return (
    <ReportChipContainer>
      <ReportChip
        icon={<Icon fontSize="inherit" />}
        label={label}
        onClick={() => !loading && onClick()}
        loading={loading}
        clickable
        color="primary"
        href={`#${report.name}`}
      />
      {loading && <StyledCircularProgress size={20} />}
    </ReportChipContainer>
  );
};
ReportLink.propTypes = {
  loading: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  Icon: propTypes.component,
  report: propTypes.report,
};
